import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const NoTasksMessage = () => {
  return (
    <Box alignItems="center" textAlign="center" gap="s8" maxWidth="s600" paddingX="s24">
      <Icon.Large icon="document-edit" />
      <Text weight="medium" size="400" color="grey1000">
        {i18n.t('project_management.tasks.table.no_tasks_message.title')}
      </Text>
      <Text weight="normal" size="300" color="grey800">
        {i18n.t('project_management.tasks.table.no_tasks_message.description')}
      </Text>
    </Box>
  )
}

export default NoTasksMessage
